import React from "react";
import { ProductVariantAttributeWithValues, ProductVariant } from "../../types/ProductVariant";

interface ProductVariantSelectorProps {
  variantAttributes: ProductVariantAttributeWithValues[];
  selectedAttributes: Record<string, string>;
  selectedVariant: ProductVariant | null;
  onChange: (attributeId: string, valueId: string) => void;
}

const tones = [
  "linear-gradient(135deg, #E8C57A, #B68B3F)",
  "linear-gradient(135deg, #E8E8E8, #A8A8A8)",
  "linear-gradient(135deg, #EAC9B6, #B58875)",
  "linear-gradient(135deg, #D9C2A2, #9E7F55)",
  "linear-gradient(135deg, #F4E8D2, #C2965E)",
];

export default function ProductVariantSelector({
  variantAttributes,
  selectedAttributes,
  selectedVariant,
  onChange,
}: ProductVariantSelectorProps) {
  if (!variantAttributes || variantAttributes.length === 0) {
    return null;
  }

  return (
    <div style={{ display: "grid", gap: 12 }}>
      {variantAttributes.map((attr) => {
        const selectedValueId = selectedAttributes[attr.idProductoAtributo];
        const selectedValue = attr.valores.find((value) => value.idProductoAtributoValor === selectedValueId);

        return (
          <div key={attr.idProductoAtributo} className="lg-strong" style={{ padding: "20px 24px", borderRadius: 22 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <div className="eyebrow">{attr.nombreAtributo}</div>
              <span style={{ fontSize: 12, color: "var(--ink-700)", fontWeight: 500 }}>
                {selectedValue?.nombreValor || "Seleccionar"}
              </span>
            </div>

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              {attr.valores
                .slice()
                .sort((a, b) => a.nombreValor.localeCompare(b.nombreValor, "es", { sensitivity: "base" }))
                .map((value, index) => {
                  const active = value.idProductoAtributoValor === selectedValueId;
                  return (
                    <button
                      key={value.idProductoAtributoValor}
                      type="button"
                      onClick={() => onChange(attr.idProductoAtributo, value.idProductoAtributoValor)}
                      title={value.nombreValor}
                      style={{
                        padding: 4,
                        borderRadius: 999,
                        border: active ? "2px solid var(--ink-900)" : "2px solid transparent",
                        background: "transparent",
                        cursor: "pointer",
                      }}
                    >
                      <span
                        style={{
                          minWidth: value.nombreValor.length > 3 ? 52 : 36,
                          height: 36,
                          padding: value.nombreValor.length > 3 ? "0 12px" : 0,
                          borderRadius: 999,
                          background: tones[index % tones.length],
                          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6), 0 2px 6px rgba(0,0,0,0.15)",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "var(--ink-900)",
                          fontSize: 11,
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {value.nombreValor.length > 3 ? value.nombreValor : ""}
                      </span>
                    </button>
                  );
                })}
            </div>

            {selectedVariant && (
              <div className="mono" style={{ marginTop: 12, fontSize: 11, color: "var(--ink-500)" }}>
                Variante {selectedVariant.SKU}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
